import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { AddIcon, CheckmarkIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button } from '@treams/treams-ui';

import LearningItemCard from '../../packages/kakapo-ui-application/pages/learning/components/LearningItemCard';

export default function GoalLearningSuggestionCard({
	course,
	reason,
	added,
	onAdd,
}: {
	course: graphql.LearningCourseFragment;
	reason?: string | null;
	added: boolean;
	onAdd: (course: graphql.LearningCourseFragment) => void;
}) {
	const { t } = useTranslation();

	const handleAdd = useCallback(() => {
		onAdd(course);
	}, [onAdd, course]);

	return (
		<Box flexGrow={1} flexBasis={0} minWidth={0} title={reason ?? undefined}>
			<LearningItemCard course={course}>
				<Button
					type="secondary"
					small
					width={1}
					icon={added ? <CheckmarkIcon /> : <AddIcon />}
					title={
						added
							? t('goals.edit.learningSuggestions.added')
							: t('goals.edit.learningSuggestions.add')
					}
					disabled={added}
					onClick={handleAdd}
				/>
			</LearningItemCard>
		</Box>
	);
}

export function GoalLearningSuggestionCardSkeleton() {
	return (
		<Box flexGrow={1} flexBasis={0} minWidth={0}>
			<LearningItemCard.Skeleton />
		</Box>
	);
}
